import axios from 'axios';

// Always use current origin — works on preview, production, or any domain
const API = axios.create({
  baseURL: `${window.location.origin}/api`,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('offerflow_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('offerflow_token');
      localStorage.removeItem('offerflow_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default API;
